import { render, staticRenderFns } from "./DriverList.vue?vue&type=template&id=a8b8ce9c"
import script from "./DriverList.vue?vue&type=script&setup=true&lang=js"
export * from "./DriverList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports